function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useRef, useState } from "react";
import { withNativeProps } from "../../utils/with-native-props";
import { ImageIcon } from "./image-icon";
import { BrokenImageIcon } from "./broken-image-icon";
import { mergeProps } from "../../utils/mergeProps";
import { useIsomorphicUpdateLayoutEffect } from "../../utils/use-isomorphic-update-layout-effect";
import { toCSSLength } from "../../utils/to-css-length";
import { LazyDetector } from "./lazy-detector";
var classPrefix = "tc-image";
var defaultProps = {
  fit: "fill",
  lazy: false,
  draggable: false,
  placeholder: /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-tip")
  }, /*#__PURE__*/React.createElement(ImageIcon, null)),
  fallback: /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-tip")
  }, /*#__PURE__*/React.createElement(BrokenImageIcon, null))
};
var Image = function Image(p) {
  var props = mergeProps(defaultProps, p);
  var lazy = props.lazy,
    fallback = props.fallback,
    alt = props.alt,
    fit = props.fit,
    crossOrigin = props.crossOrigin,
    width = props.width,
    height = props.height,
    placeholder = props.placeholder,
    decoding = props.decoding,
    loading = props.loading,
    referrerPolicy = props.referrerPolicy,
    sizes = props.sizes,
    useMap = props.useMap,
    draggable = props.draggable,
    onClick = props.onClick,
    _onError = props.onError,
    _onLoad = props.onLoad;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    failed = _useState4[0],
    setFailed = _useState4[1];
  var _useState5 = useState(!lazy),
    _useState6 = _slicedToArray(_useState5, 2),
    initialized = _useState6[0],
    setInitialized = _useState6[1];
  var ref = useRef(null);
  var src = props.src;
  var srcSet = props.srcSet;
  src = initialized ? props.src : undefined;
  srcSet = initialized ? props.srcSet : undefined;
  useIsomorphicUpdateLayoutEffect(function () {
    setLoaded(false);
    setFailed(false);
  }, [src]);
  function renderInner() {
    if (failed) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, fallback);
    }
    var img = /*#__PURE__*/React.createElement("img", {
      className: "".concat(classPrefix, "-img"),
      src: src,
      alt: alt,
      onClick: onClick,
      onLoad: function onLoad(e) {
        setLoaded(true);
        _onLoad === null || _onLoad === void 0 ? void 0 : _onLoad(e);
      },
      onError: function onError(e) {
        setFailed(true);
        _onError === null || _onError === void 0 ? void 0 : _onError(e);
      },
      style: {
        objectFit: fit,
        display: loaded ? "block" : "none"
      },
      crossOrigin: crossOrigin,
      decoding: decoding,
      loading: loading,
      referrerPolicy: referrerPolicy,
      sizes: sizes,
      srcSet: srcSet,
      useMap: useMap,
      draggable: draggable
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, !loaded && placeholder, img);
  }
  var style = {};
  if (width) {
    style["--width"] = toCSSLength(width);
    style.width = toCSSLength(width);
  }
  if (height) {
    style["--height"] = toCSSLength(height);
    style.height = toCSSLength(height);
  }
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classPrefix,
    style: style,
    onClick: props.onContainerClick
  }, props.lazy && !initialized && /*#__PURE__*/React.createElement(LazyDetector, {
    onActive: function onActive() {
      setInitialized(true);
    }
  }), renderInner()));
};
Image.defaultProps = Object.assign({}, defaultProps);
export default Image;